import React, { useEffect } from "react"

import { CategoriesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function ReportExtraCategoriesField() {

	const {
		filterCategories,
		setFilterCategoriesInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterCategories, "filterCategories", object({ filterCategories: array().required("Must provide a category").min(1, "Must provide a category") }))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setFilterCategoriesInfo([], false)
		}
	}, [])

	return <CategoriesAutocomplete
		value={filterCategories || []}
		onChange={e => setFilterCategoriesInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/category`}
	/>

}